__turbopack_context__.v({
  "basis": "VV2_YG_basis",
  "disc": "VV2_YG_disc",
  "figure": "VV2_YG_figure",
  "grid": "VV2_YG_grid",
  "logo": "VV2_YG_logo",
  "outOf": "VV2_YG_outOf",
  "platform": "VV2_YG_platform",
  "platformName": "VV2_YG_platformName",
  "platformScore": "VV2_YG_platformScore",
  "platformsLabel": "VV2_YG_platformsLabel",
  "platformsSolo": "VV2_YG_platformsSolo",
  "score": "VV2_YG_score",
  "stars": "VV2_YG_stars",
  "summary": "VV2_YG_summary",
});
